<template>
  <div class="cart">
    <div class="cart__content">
      <div class="cart__col cart__col_event">
        <Event
          :item="event"
          :has-rules-link="false"
        />
      </div>
      <div class="cart__col cart__col_tickets">
        <div class="cart__tickets pretty-scrollbar">
          <div
            v-for="item in tickets"
            :key="`cart_ticket_${item.id}`"
            class="cart__ticket"
          >
            <div class="cart__seat">
              {{ $t('texts.rowNumber', [item.row]) }},
              {{ $t('texts.seatNumber', [item.seat]) }}
            </div>
            <div class="cart__price">
              {{ item.price | sum }}
            </div>
            <BaseIconButton
              icon="cross"
              class="cart__remove"
              @click="$emit('remove', item.id)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="cart__footer">
      <BaseTitle
        :text="totalText"
        :is-fat="false"
        size="m"
        is-normal
        is-up
      />
      <BaseButton
        :text="$t('actions.continue')"
        :href="nextPath"
        size="s"
        class="cart__action"
      />
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIconButton from '@/components/BaseIconButton.vue';
import Event from '@/components/Event.vue';

export default {
  name: 'Cart',
  components: {
    BaseTitle,
    BaseButton,
    BaseIconButton,
    Event,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    tickets: {
      type: Array,
      default: () => [],
    },
    sum: {
      type: Number,
      default: 0,
    },
    nextPath: {
      type: String,
      default() {
        return this.$router.options.paths.buyForm;
      },
    },
  },
  computed: {
    totalText() {
      return this.$t('texts.paySum') + this.$options.filters.sum(this.sum, true);
    },
  },
};
</script>

<style lang="stylus">
.cart
  display block
  width 100%
  height 100%

  &__content
    display flex
    border solid currentColor
    border-width 0.25em 0
    height calc(100% - 5em)
    padding 2em 0

  &__col
    position relative
    flex-grow 1
    flex-basis 0
    max-width 50%

    &_event
      align-self center

    &_tickets
      max-width 100%
      &:after
        content ''
        abs bottom left right
        height 2em
        background-color red
        background linear-gradient(180deg, alpha(#fff, 0), #fff)
        pointer-events none
        margin 0 1em
        z-index 1

  &__tickets
    width 100%
    height 100%
    padding-left 5em
    padding-right calc(5em - 11px)
    overflow-y scroll
    border-left 0.12em dotted currentColor

  &__ticket
    display flex
    align-items center
    padding 1.25em 0
    border-top 1px solid alpha($c_text, 15%)
    &:first-child
      padding-top 0
      border-color transparent

  &__seat
    width 50%
    text-transform lowercase
    &:first-letter
      text-transform uppercase

  &__remove
    margin-left auto

  &__footer
    display flex
    align-items center
    justify-content flex-end
    height 5em
    padding-top 2em
    text-align right

  &__action
    margin-left 3em
</style>
